import React from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-final-form";
import { TextField } from "@syos-music/form";

import { InputAdornment } from "@mui/material";

export default function PriceField({ name, ...props }) {
  const intl = useIntl();
  const form = useForm();

  const currencySymbol = React.useMemo(() => {
    form.registerField(name, () => null, {});
    const { currency } = form.getFieldState(name)?.value ?? {};

    return intl
      .formatNumber(0, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      })
      .replace(/[0\s]/g, "");
  }, [intl, form, name]);

  return (
    <TextField
      type="number"
      {...props}
      name={`${name}.value`}
      InputProps={{
        inputProps: { step: 0.01 },
        endAdornment: (
          <InputAdornment position="end">{currencySymbol}</InputAdornment>
        ),
      }}
    />
  );
}
